<template>
  <div class="icon-button" :style="styleObj">
    <img :src="props.image" :alt="props.altText" class="icon-button-img" />
    <div class="icon-button-text">
      {{ props.text }}
    </div>
  </div>
</template>

<script setup>
// Props
const props = defineProps({
  image: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  altText: {
    type: String,
    required: true,
  },
  width: {
    type: String,
    required: false,
    default: 'auto',
  },
})

const styleObj = computed(() => ({ width: props.width }))
</script>
